import PropTypes from 'prop-types';
import React from 'react';
import { getComponentClasses } from '@99designs/utils/app';

const Ribbon = props => (
    <div className={getComponentClasses('ribbon', props.variations)}>
        <div className="ribbon__text">{props.children}</div>
    </div>
);

Ribbon.propTypes = {
    variations: PropTypes.array,
};

export default Ribbon;



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/Ribbon.jsx